module.exports = __webpack_public_path__ + "static/img/ad_pic.9ae4636.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/creation/ad_pic.png
// module id = Mlt+
// module chunks = 1